import type { AgentEdge, AgentNode } from '@saaga/shared/interfaces/agency-node.interface'

import { getChildNodeIdList, hasChildNodes } from './agency-flow-layout.util'

export interface DeleteNodeResult {
  success: boolean
  hasChildren: boolean
  childNodeIdList: string[]
}

const FAILED_RESULT: DeleteNodeResult = { success: false, hasChildren: false, childNodeIdList: [] }

export const canDeleteNode = (
  nodeId: string,
  nodeList: AgentNode[],
  edgeList: AgentEdge[]
): DeleteNodeResult => {
  const node = nodeList.find((n) => n.id === nodeId)
  if (!node) return FAILED_RESULT
  if (node.data.isEntryPoint) return FAILED_RESULT

  if (hasChildNodes(nodeId, edgeList)) {
    return {
      success: false,
      hasChildren: true,
      childNodeIdList: getChildNodeIdList(nodeId, edgeList),
    }
  }

  return { success: true, hasChildren: false, childNodeIdList: [] }
}
